import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, webPageJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/nosotros";
const DESCRIPTION =
  "Company dossier de Shugert: Shopify Partner desde 2015, más de 750 colaboraciones, scopes documentados, releases controlados y validación medible.";
const MODIFIED = "2026-08-19T00:00:00.000Z";

export const Route = createFileRoute("/es/nosotros/")({
  loader: async () => {
    await setEdgeHtmlCache();
  },
  head: () =>
    buildHead({
      locale: "es",
      title: "Sobre Shugert: Firma Senior de Ingeniería Shopify",
      description: DESCRIPTION,
      path: PATH,
      altPath: alternatePath(PATH, "en"),
      jsonLd: [
        webPageJsonLd({
          name: "Sobre Shugert: Firma Senior de Ingeniería Shopify",
          path: PATH,
          description: DESCRIPTION,
          inLanguage: "es-MX",
          dateModified: MODIFIED,
        }),
        breadcrumbJsonLd([
          { name: "Inicio", path: "/es" },
          { name: "Nosotros", path: PATH },
        ]),
      ],
    }),
});
